import { render, staticRenderFns } from "./addResurvey.vue?vue&type=template&id=6a341514&scoped=true&"
import script from "./addResurvey.vue?vue&type=script&lang=tsx&"
export * from "./addResurvey.vue?vue&type=script&lang=tsx&"
import style0 from "./addResurvey.vue?vue&type=style&index=0&id=6a341514&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a341514",
  null
  
)

export default component.exports